import React from 'react';
import { motion } from 'framer-motion';
import { Users, Target, Trophy, Clock } from 'lucide-react';
import { PerformanceMetrics } from './PerformanceMetrics';
import { PerformanceChart } from './PerformanceChart';
import { TopPerformers } from './TopPerformers';

export function PerformanceOverview() {
  const metrics = [
    {
      label: 'Active Clients',
      value: '24',
      change: '+3',
      trend: 'up',
      icon: <Users className="w-4 h-4" />
    },
    {
      label: 'Goal Completion',
      value: '87%',
      change: '+5%',
      trend: 'up',
      icon: <Target className="w-4 h-4" />
    },
    {
      label: 'Client Retention',
      value: '92%',
      change: '+2%',
      trend: 'up',
      icon: <Trophy className="w-4 h-4" />
    },
    {
      label: 'Avg. Session',
      value: '52m',
      change: '-3m',
      trend: 'down',
      icon: <Clock className="w-4 h-4" />
    }
  ];

  return (
    <div className="space-y-6">
      {/* Quick Stats */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {metrics.map((metric, index) => (
          <PerformanceMetrics key={metric.label} {...metric} index={index} />
        ))}
      </div>

      {/* Performance Chart */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <PerformanceChart />
        </div>
        <div>
          <TopPerformers />
        </div>
      </div>
    </div>
  );
}